import React, { useEffect, useState } from 'react';
import Layout from '../components/shared/layout';
import InnerPageBanner from '../components/shared/innerPageBanner';
import ImageIcons from '../components/imageComponent/ImageIcons';
import Button from '../components/shared/button';
import { IoClose } from "react-icons/io5";
import { IoCheckmarkDoneSharp } from 'react-icons/io5';
import axios from 'axios';
import Loader from "../components/shared/loader";
import { validateEmail } from "../utils/formFunctions";
import SEO from '../components/shared/seo';



// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.js',
//   import.meta.url,
// ).toString();

const Career = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeJobIndex, setActiveJobIndex] = useState(null);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('overflow-hidden', showModal);

    return () => {
      document.body.classList.remove('overflow-visible');
    };
  }, [showModal]);

  const [newdata, setNewdata] = useState([])
  const toggleModal = (data) => {
    console.log("kuch bhi", data._id)
    // var riya = data._id
    setNewdata(data?._id)
    setShowModal(!showModal);
  };
  // const [defaults, setDefaults] = useState(newdata);
  // console.log("defaults",defaults)

  // const [defaults, setDefaults] = useState(newdata?._id);
  // console.log("defaults",defaults)
  // console.log(">>>>", newdata) 

  const closeModal = () => {
    setShowModal(false);
    // Reset form data state
    setFormData({
      fullName: '',
      phoneNumber: '',
      email: '',
      location: '',
      qualification: '',
      experience: ''
    });
    // Reset upload resume state
    setUploadResume('');
  };
  const windowOnClick = (event) => {
    if (event.target.classList.contains('modal')) {
      closeModal();
    }
  };

  const toggleJobDetails = (index) => {
    console.log("item", index)
    setActiveJobIndex(activeJobIndex === index ? null : index);
  };



  const [uploadResume, setUploadResume] = useState('');

  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    location: '',
    email: '',
    qualification: '',
    experience: '',

  })

  const [errors, setErrors] = useState({
    fullName: '',
    phoneNumber: '',
    location: '',
    email: '',
    qualification: '',
    experience: '',
    uploadResume: ''

  });
  const [jobData, setJobData] = useState([])


  const fetchData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_URL}user/getcarrer`);
      setJobData(response?.data?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!showModal) {
      setNewdata(null); // Reset newdata when modal is closed
    }
  }, [showModal]);

  const [designation, setDesignation] = useState([])
  console.log("designation", designation)


  const fetchDatas = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_URL}admin/getqualification`);
      console.log("response.data", response)
      setDesignation(response?.data?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    fetchDatas();
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      setErrors(prevState => ({ ...prevState, uploadResume: "Please select an image file." }));
      setUploadResume('');
      return;
    }

    if (!selectedFile.type.startsWith("application/pdf") && !selectedFile.type.startsWith("application/msword")) {
      setErrors(prevState => ({ ...prevState, uploadResume: "Please select a valid image file." }));
      setUploadResume('');
      return;
    }
    else {
      setFormData((prevState) => ({
        ...prevState,
        uploadResume: e.target.value,
      }));
      setErrors((prevState) => ({
        ...prevState,
        uploadResume: false,
        message: "",
      }));
    }

    setUploadResume(selectedFile);
    e.target.value = null;

  };

  const firstNameHandler = (e) => {
    const inputValue = e.target.value; // Remove leading and trailing spaces
    const alphaValue = inputValue.replace(/[^A-Za-z\s]/g, '');
    // Capitalize the first letter of each word
    const capitalizedValue = alphaValue.replace(/\b\w/g, (match) => match.toUpperCase());

    if (capitalizedValue.length >= 30) {
      setErrors((prevState) => ({ ...prevState, fullName: "Full Name must be less than or equal to 30 characters" }));
    } else {
      setFormData((prevState) => ({ ...prevState, fullName: capitalizedValue }));
      setErrors((prevState) => ({ ...prevState, fullName: "" }));
    }
  };


  const handlePhoneInputChange = (e) => {
    const inputValue = e.target.value.trim();
    const numericValue = inputValue.replace(/\D/g, ""); // Remove non-digit characters

    if (numericValue.length <= 10) {
      setFormData((prevState) => ({ ...prevState, phoneNumber: numericValue }));
      setErrors((prevState) => ({ ...prevState, phoneNumber: false }));
    }

  }
  // const repeatingDigitsRegex = /(\d)\1{9,}/;
  // if (repeatingDigitsRegex.test(numericValue)) {
  //     // If repeating digits are found, display an error message
  //     setErrors((prevState) => ({ ...prevState, phoneNumber: true, message: "Phone number cannot consist of repeating digits." }));
  // }



  // const validateEmail = (email) => {
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   return emailRegex.test(email);
  // };

  // const handleEmailChange = (e) => {
  //   const emailValue = e.target.value.trim();
  // setFormData((prevState) => ({
  //   ...prevState,
  //   email: emailValue,
  // }));
  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //     if (!emailValue === emailRegex) {
  //   setErrors((prevState) => ({
  //     ...prevState,
  //     email: 'Invalid email format',
  //   }));
  // }else {
  //     setFormData((prevState) => ({ ...prevState, email: emailValue }));
  //     setErrors((prevState) => ({ ...prevState, email: false,email: "" }));
  //   }
  // };

  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   setFormData({ ...formData, [name]: value });

  // };

  const validateForm = () => {
    let newErrors = {};
    setDisabled(true);
    if (!formData.fullName) newErrors.fullName = 'FullName is required';
    if (!formData.phoneNumber) newErrors.phoneNumber = 'PhoneNumber is required';
    if (!formData.location) newErrors.location = 'Location is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.qualification) newErrors.qualification = 'Qualification is required'; // Validation for logo
    if (!formData.experience) newErrors.experience = 'Experience is required'; // Validation for logo
    if (!uploadResume) newErrors.uploadResume = 'Resume is required'; // Validation for logo

    setErrors(newErrors);
    setDisabled(false);
    return Object.keys(newErrors).length === 0;
  };

  const validRegex = /^(?!.*(\d)\1{9})[6-9]\d{9}$/;
  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabled(true);

    if (!validateForm()) {
      console.log('Validation Failed');
      return;
    } else if (formData.phoneNumber.length < 10) {
      setErrors((prevState) => ({
        ...prevState,
        // phoneNumber: true,
        phoneNumber: "Phone number is invalid!",
      }));
      setDisabled(false);
    } else if (!validRegex.test(formData.phoneNumber)) {
      setErrors((prevState) => ({
        ...prevState,
        // phone: true,
        phoneNumber: "Phone number must be valid !",
      }));
      setDisabled(false);
      // else if (/^(\d)\1*$/.test(longitude)) {
      //     alert("Latitude must be a valid number");
    } else if (!validateEmail(formData.email)) {
      setErrors((prevState) => ({
        ...prevState,
        // email: true,
        email: "Email is invalid!",
      }));
      setDisabled(false);
    } else if (formData.qualification === '000000') {
      setErrors((prevState) => ({
        ...prevState,
        qualification: "Qualification cannot be 0."
      }));
      setDisabled(false);
    } else if (formData.qualification.charAt(0) === '0') {
      setErrors((prevState) => ({
        ...prevState,
        qualification: "Qualification cannot start with '0'.",
      }));

      setDisabled(false);
    } else if (formData.experience === '000000') {
      setErrors((prevState) => ({
        ...prevState,
        experience: "Experience cannot be 0."
      }));
      setDisabled(false);
    } else if (formData.experience.charAt(0) === '0') {
      setErrors((prevState) => ({
        ...prevState,
        experience: "Experience cannot start with '0'.",
      }));

      setDisabled(false);
    }
    else {
      setDisabled(true);
      const formDataToSend = new FormData();
      formDataToSend.append("fullname", formData.fullName);
      formDataToSend.append("phone", formData.phoneNumber);
      formDataToSend.append("location", formData.location);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("qualification", formData.qualification);
      formDataToSend.append("designation", newdata);
      formDataToSend.append("experiance", formData.experience);
      formDataToSend.append("image", uploadResume);

      try {
        const response = await axios.post(`${process.env.REACT_APP_URL}user/addcarrerform`, formDataToSend);
        console.log("response===>>>>>>>>>>>>>>", response)

        if (response.data) {
          setTimeout(() => {
            setErrors((prevState) => ({ ...prevState, success: false }));
            setDisabled(false);
            setFormData({
              fullName: '',
              phoneNumber: '',
              email: '',
              location: '',
              qualification: '',
              experience: ''
            });
            setUploadResume('');
            setShowModal(false);


          }, 3000);

        }
        setErrors((prevState) => ({ ...prevState, success: true }));
      }
      catch (errors) {
        console.log('Error adding customer:', errors);
        setErrors(prevState => ({ ...prevState, message: errors.response.data }));
        setDisabled(false);
      }
    }
  };
  console.log("newdata", newdata)
  return (
    <>
      <SEO title='Careers at My Internet Services - Join Our Team' description='Find career opportunities at My Internet . Join our dynamic team and grow your career in the tech industry. Apply now for various roles and make a difference!' />
      <Layout>
        <InnerPageBanner title='Career' innerPageBanner={ImageIcons.Career} />
        <section className='lg:mt-[25px] mt-[15px] relative pb-[0]'>
          <div className='absolute lg:w-[200px] md:w-[100px] w-[80px] left-[20px] lg:bottom-[-250px] md:bottom-[-200px] bottom-[-130px] animate-[animate-bounceTop_5s_infinite_ease-in-out_alternate] opacity-[0.2]'>
            <img className='object-cover' src={ImageIcons.hiring} alt='hiring' />
          </div>
          <div className='container '>
            <div className='flex lg:flex-nowrap flex-wrap lg:gap-[50px] gap-[40px] items-center'>
              <div className='lg:w-[50%] max-lg:order-2 w-full lg:py-[40px] py-0 relative ' >
                <div className='relative z-10'>
                  <h2 className='font-bold'>We are<span className='text-[#f38432]'> Hiring!</span></h2>
                  <p className='text-[18px]'>We are on the hunt for the next generation of innovators with new ideas and visions to make this world a better place for everyone. If you’re one of those who knows how to carve new paths in a crowded territory, our company would love to talk to you.</p>
                  <p className='text-[18px]'>So, what are you waiting for? <br /> Grab the opportunity to become a part of our organization. We want to hear from your side.</p>
                  <Button hrefLink='#' title='Learn More' />
                </div>
              </div>
              <div className='md:min-h-[500px] max-lg:order-1 sm:min-h-[400px] md:mr-[25px] mr-[15px] min-h-[300px] relative lg:w-[50%] w-full after:content-[""] after:absolute after:rounded-[20px] md:after:top-[-25px] after:top-[-15px] md:after:right-[-25px] after:right-[-15px] after:w-[calc(100%_-_50%)] after:z-[-1] after: after:bg-[#f38432] after:h-full'>
                <img className='object-cover h-full w-full absolute rounded-[20px]' src={ImageIcons.jobOpening} alt='job Opening' />
              </div>
            </div>
          </div>
        </section>

        <section className='relative'>
          <div className='container'>
            <div className='max-w-[800px] md:mb-[50px] mb-[40px] text-center mx-auto'>
              <div className='text-[#f48533] uppercase mb-[5px] '>Hiring</div>
              <h2>Recent <span className='text-[#f48533]'>Job</span> Listing</h2>
            </div>
            <div className=''>
              {jobData.map((item, i) => (
                <div key={i} className='shadow-[0_0_10px_4px_rgba(0,0,0,0.05)] bg-[#fff] mb-[20px] lg:px-[40px] sm:px-[30px] px-[20px] sm:py-[30px] py-[20px] rounded-[10px]'>
                  <div className='flex md:flex-row flex-col md:items-center items-start justify-between '>
                    <div className=''>
                      <h4>{item.title}</h4>

                      <div className='flex gap-[15px] max-md:mb-[20px]'>
                        <div class="border min-w-[130px] max-md:border-0 max-sm:w-full px-4 max-md:p-0 py-2.5 rounded-[10px] border-solid border-[#f48533] text-center">
                          <div>Experience</div>
                          <h4 className='mb-0 text-[#f48533] sm:text-[24px] text-[20px]'>{item.experiance}</h4>
                        </div>

                        <div class="border min-w-[130px] max-md:border-0 max-sm:w-full px-4 max-md:p-0 py-2.5 rounded-[10px] border-solid border-[#f48533] text-center">
                          <div>Positions</div>
                          <h4 className='mb-0 text-[#f48533] sm:text-[24px] text-[20px]  '>{item.positions}</h4>
                        </div>
                      </div>
                    </div>

                    <div className='inline-flex sm:gap-[15px] gap-[8px] max-md:w-full'>
                      <button onClick={() => toggleJobDetails(item)} className='sm:px-[30px] max-sm:w-full px-[10px] duration-500 sm:text-[17px] text-[16px] py-[15px] font-medium text-[#fff] rounded-[10px] bg-[#000] hover:bg-[#f48533] ease inline-block'>View Details</button>
                      <button onClick={() => toggleModal(item)} className='sm:px-[30px] max-sm:w-full px-[10px] duration-500 sm:text-[17px] text-[16px] py-[15px] font-medium text-[#fff] bg-[#f48533] rounded-[10px] hover:bg-[#000] ease inline-block'>Apply Now</button>
                    </div>
                  </div>

                  {activeJobIndex === item &&
                    <div className='mt-[30px] md:p-[30px] p-[20px] bg-[#fff3ea] rounded-[10px]'>
                      <h5 className='text-[18px]'>Job Title: <span className='text-[17px] font-normal'>{activeJobIndex.title}</span></h5>
                      <h5 className='text-[18px]'>Location: <span className='text-[17px] font-normal'>{activeJobIndex.location}</span></h5>
                      <h5 className='text-[18px]'>Job Type: <span className='text-[17px] font-normal'>{activeJobIndex.jobtype}</span></h5>
                      <h5 className='text-[18px]'>Experience: <span className='text-[17px] font-normal'>{activeJobIndex.experiance}</span></h5>
                      <h5 className='text-[18px]'>Number of Positions: <span className='text-[17px] font-normal '>{activeJobIndex.positions}</span></h5>
                      <h5 className='text-[18px] mb-[15px]'>Job Description</h5>
                      <p>{activeJobIndex.jobdescription}</p>
                      <h5 className='text-[18px] mb-[15px]'>Required Skills and Qualifications:</h5>
                      <ul >
                        {item.skills.map((item, i) => (
                          <li key={i} className='mb-[6px] text-[16px] relative pl-[25px]'><IoCheckmarkDoneSharp className='text-[17px] inline-block text-[#f48533] absolute left-0 top-[5px]' /> {item}</li>
                        ))}
                      </ul>
                    </div>
                  }
                </div>
              ))}
            </div>
          </div>
        </section>

        {showModal && (
          <div className="modal fixed w-full h-full bg-[rgba(0,0,0,0.8)] z-[99999] overflow-y-auto left-0 top-0" onClick={windowOnClick}>
            <div className="relative overflow-y-hidden bg-[white] max-w-[750px] rounded-lg sm:my-[40px] my-[30px] md:mx-auto mx-[20px]">
              <div className='flex items-center justify-between sm:px-[30px] px-[20px] py-[18px] bg-[#f48533] text-white'>
                <h4 className='mb-0'>Enter Your Details</h4>
                <span className="cursor-pointer rounded" onClick={closeModal}>
                  <IoClose className='text-[25px]' />
                </span>
              </div>

              <div className='sm:px-[30px] px-[20px] sm:py-[30px] py-[20px]'>
                {disabled && <Loader />}
                <form className="grid sm:grid-cols-2 grid-cols-1 md:gap-[20px] gap-[15px]" onSubmit={handleSubmit}>
                  <div>
                    <label className="mb-[8px] inline-block" htmlFor="fullName">Full Name*</label>
                    <input
                      id="fullName"
                      type='text'
                      name="fullName"
                      value={formData.fullName}
                      onChange={firstNameHandler}
                      className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                    />
                    {errors.fullName && <p className="text-[#ff0000]">{errors.fullName}</p>}
                  </div>

                  <div>
                    <label className="mb-[8px] inline-block" htmlFor="phoneNo">Phone Number*</label>
                    <input
                      id="phoneNumber"
                      type='text'
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handlePhoneInputChange}
                      className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                    />
                    {errors.phoneNumber && <p className="text-[#ff0000]">{errors.phoneNumber}</p>}
                  </div>

                  <div>
                    <label className="mb-[8px] inline-block" htmlFor="email">Email*</label>
                    <input
                      id="email"

                      name="email"
                      value={formData.email}
                      onChange={(e) => {
                        setFormData((prevState) => ({
                          ...prevState,
                          email: e.target.value,
                        }));
                        setErrors((prevState) => ({
                          ...prevState,
                          email: false,
                          message: "",
                        }));
                      }}
                      className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                    />
                    {errors.email && <p className="text-[#ff0000]">{errors.email}</p>}
                  </div>

                  <div>
                    <label className="mb-[8px] inline-block" htmlFor="Location">Location*</label>
                    <input
                      id="Location"
                      type='text'
                      name="location"
                      value={formData.location}
                      onChange={(e) => {
                        setFormData((prevState) => ({
                          ...prevState,
                          location: e.target.value,
                        }));
                        setErrors((prevState) => ({
                          ...prevState,
                          location: false,
                          message: "",
                        }));
                      }}
                      className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                    />
                    {errors.location && <p className="text-[#ff0000]">{errors.location}</p>}
                  </div>

                  <div>
                    <label className="mb-[8px] inline-block" htmlFor="designation">Designation*</label>
                    <select defaultValue={newdata} onChange={(e) => setNewdata(e.target.value)} id="number" className='w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]' >
                      {jobData?.map((item, i) => (
                        <option key={i} value={item?._id} >{item?.title}</option> // Assuming item has _id property
                      ))}
                    </select>

                    {errors.designation && <p className="text-[#ff0000]">{errors.designation}</p>}
                  </div>

                  <div>
                    <label className="mb-[8px] inline-block" htmlFor="experience">Experience</label>
                    <input
                      id="experience"
                      type='text'
                      name="experience"
                      value={formData.experience}
                      onChange={(e) => {
                        setFormData((prevState) => ({
                          ...prevState,
                          experience: e.target.value,
                        }));
                        setErrors((prevState) => ({
                          ...prevState,
                          experience: false,
                          message: "",
                        }));
                      }}
                      className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                    />
                    {errors.experience && <p className="text-[#ff0000]">{errors.experience}</p>}
                  </div>

                  <div>
                    <label className="mb-[8px] inline-block" htmlFor="qualification">Qualification*</label>
                    <input
                      id="qualification"
                      type='text'
                      name="qualification"
                      value={formData.qualification}
                      onChange={(e) => {
                        setFormData((prevState) => ({
                          ...prevState,
                          qualification: e.target.value,
                        }));
                        setErrors((prevState) => ({
                          ...prevState,
                          qualification: false,
                          message: "",
                        }));
                      }}
                      className="w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                    />
                    {errors.qualification && <p className="text-[#ff0000]">{errors.qualification}</p>}
                  </div>

                  <div>
                    <label className="mb-[8px] inline-block" htmlFor="upload">Upload Resume*</label>
                    <div className="relative flex items-center w-full h-[50px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]">
                      <input
                        type="file"
                        className="opacity-0 absolute top-0 left-0 w-full h-full cursor-pointer z-10"
                        id="uploadLogo"
                        onChange={(e) => handleFileChange(e)}
                      />
                      <label htmlFor="uploadLogo">
                        {uploadResume.name}
                      </label>

                      <div className="absolute flex items-center top-0 right-0 h-full px-[25px] text-[17px] duration-500 text-[#fff] bg-[#f48533] rounded-r-[5px] hover:bg-[#000]">Upload</div>
                    </div>
                    {errors.uploadResume && <p className="text-[#ff0000]">{errors.uploadResume}</p>}
                  </div>

                  <div className="sm:col-span-2 col-span-1 text-center">
                    <button className="px-[50px] max-sm:w-full text-[17px] py-[13px] font-medium text-[#fff] bg-[#f48533] rounded-[10px] hover:bg-[#000] ease inline-block">Apply</button>
                  </div>
                </form>

              </div>
            </div>
          </div>
        )}
      </Layout>
    </>
  )
};



export default Career;